import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ua from './langs/ua.json';
//import ru from './langs/ru.json';

Vue.use(VueI18n);

export default new VueI18n({
	locale: 'ua',
	fallbackLocale: 'ru',
	silentTranslationWarn: true,
	messages: {
		ua
	}
});
